import React from "react";
import SpinnerRound from "../spinner/spinnerRound";
// dangerGhost is the default destructive skin, not danger — brand and danger separate by fill vs ghost, not by hue.
const VARIANTS = {
    primary: {
        bg: "bg-brand-600 hover:bg-brand-700 active:bg-brand-800 shadow-card",
        text: "text-white",
    },
    secondary: {
        bg: "bg-white border border-line-strong hover:border-brand-400 hover:bg-brand-50 active:bg-brand-100 shadow-card",
        text: "text-gray-700 hover:text-brand-700",
    },
    ghost: {
        bg: "bg-transparent hover:bg-sunken active:bg-line",
        text: "text-gray-600 hover:text-brand-700",
    },
    danger: {
        bg: "bg-danger hover:bg-danger-strong active:bg-danger-strong shadow-card",
        text: "text-white",
    },
    dangerGhost: {
        bg: "bg-white border border-danger/40 hover:border-danger hover:bg-danger-soft active:bg-danger-soft shadow-card",
        text: "text-danger",
    },
};
export function Button({ type = "button", color, textColor, variant = "primary", fullWidth, children, className, onClick, disabled = false, title, isLoading = false, small = false, }) {
    const preset = VARIANTS[variant] ?? VARIANTS.primary;
    return (<button onClick={onClick ?? undefined} type={type} aria-busy={isLoading || undefined} className={`
                ${color ? color : preset.bg}
                ${textColor ? textColor : preset.text}
                ${fullWidth ? "w-full" : ""}
                ${small ? "py-2 px-3.5 text-sm min-h-9" : "py-2.5 px-5 min-h-11"}
                inline-flex items-center justify-center rounded-xl font-medium cursor-pointer
                pressable focus-ring tap-target
                disabled:cursor-not-allowed disabled:opacity-45 disabled:shadow-none
                ${isLoading ? "relative" : ""}
                ${className ?? ""}
            `} disabled={disabled || isLoading}>
            {/* Label stays mounted (opacity-0) while loading so width holds and aria-busy still has a name to announce. */}
            <span className={`inline-flex items-center justify-center ${isLoading ? "opacity-0" : ""}`}>
                {title ? <span>{title}</span> : children}
            </span>
            {isLoading && (<SpinnerRound className={`absolute inset-0 m-auto ${small ? "w-5 h-5" : "w-6 h-6"}`} color={"currentColor"}/>)}
        </button>);
}
//# sourceMappingURL=button.jsx.map